// Storage keys used by LaunchDarkly Session Replay SDK
// These match the internal storage patterns used by the SDK for session tracking
const LAUNCHDARKLY_STORAGE_KEYS = {
	SESSION_ID: 'sessionID',
	SESSION_DATA_PREFIX: 'sessionData_',
} as const;

/**
 * Clear LaunchDarkly localStorage keys (used on logout and user switches)
 * Note: Does not clear impersonation info - that should only be cleared when starting a new impersonation
 */
export function clearLaunchDarklyStorage(): void {
	const allKeys = Object.keys(localStorage);
	const ldKeys = allKeys.filter(
		key => key === LAUNCHDARKLY_STORAGE_KEYS.SESSION_ID || key.startsWith(LAUNCHDARKLY_STORAGE_KEYS.SESSION_DATA_PREFIX)
	);
	ldKeys.forEach(key => localStorage.removeItem(key));
}
